import { OrderTypes } from './orderTypes';

export default {
  [OrderTypes.FLIGHT]: 'search_icon.svg',
  [OrderTypes.HOTEL]: 'search_icon_hotel.svg',
  [OrderTypes.CAR]: 'search_icon_car.svg',
  [OrderTypes.BUS]: 'search_icon_bus.svg',
  [OrderTypes.OFFICE]: 'office.svg',
};
